import { RegisterForm } from "@/features/auth"
import useAuth from "@/hooks/useAuth"
import { createFileRoute, redirect } from "@tanstack/react-router"

function RegisterPage() {
  const { isAuthenticated } = useAuth()

  // Redirect to dashboard if already logged in
  if (isAuthenticated) {
    throw redirect({ to: "/" })
  }

  return (
    <RegisterForm
      onSuccess={() => {
        // Redirect handled by the form component
      }}
      redirectTo="/login"
    />
  )
}

export const Route = createFileRoute("/register")({
  component: RegisterPage,
})
